<template>
  <div class="QA-info-text">
    <h4>{{$t('askedquestion')}}</h4>
    <ul>
      <li class="accordion" v-for="(item, index) in items" :key="index" @click="handleRatio(index)">
        {{item.title}}
        <i
          :class="(selecthandleRatio === index && isAccordion) ? 'fa fa-angle-up' : 'fa fa-angle-down'"
        ></i>
        <p v-if="(selecthandleRatio === index && isAccordion)">{{item.message}}</p>
      </li>
    </ul>
  </div>
</template>

<script>
import { GOLD_QA } from "../utils/constant";
export default {
  data() {
    return {
      isAccordion: false,
      selecthandleRatio: 0,
      items: GOLD_QA
    };
  },
  methods: {
    handleRatio(index) {
      this.selecthandleRatio = index;
      if (this.selecthandleRatio === index)
        this.isAccordion = !this.isAccordion;
    }
  }
};
</script>
